"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterDiscontinuedShade = void 0;
const filterDiscontinuedShade = ({
  hexColors,
  imageUrl
}) => Boolean(hexColors && hexColors.length > 0) || Boolean(imageUrl);
exports.filterDiscontinuedShade = filterDiscontinuedShade;
//# sourceMappingURL=filterDiscontinuedShade.js.map